/**
 * Product Customize Button Handler
 * Handles clicking "Customize" buttons on product cards across the site
 * Opens the product customizer modal instead of navigating
 */

// Only initialize once
if (!window.ProductCustomizeHandlerInitialized) {
  window.ProductCustomizeHandlerInitialized = true;

class ProductCustomizeHandler {
  constructor() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    // Listen for clicks on customize buttons
    document.addEventListener('click', (e) => {
      if (!(e.target instanceof Element)) return;
      
      // Find the button by checking the click target and its parents
      let button = e.target;
      
      // If not already a button, traverse up to find the button element
      if (button.tagName !== 'BUTTON') {
        // Try using closest first
        const closestButton = button.closest('button');
        if (closestButton) {
          button = closestButton;
        } else {
          // Fallback: manual traversal up to 10 levels
          let parent = button.parentElement;
          let depth = 0;
          while (parent && parent.tagName !== 'BUTTON' && depth < 10) {
            parent = parent.parentElement;
            depth++;
          }
          if (parent && parent.tagName === 'BUTTON') {
            button = parent;
          }
        }
      }
      
      // Check if this button is a customize button - must be a button element with the right class
      if (button.tagName !== 'BUTTON') {
        return;
      }
      if (!button?.classList.contains('featured-items__customize-btn') && !button?.classList.contains('card-gallery__customize-btn')) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      // Try to get product ID from button's data attribute first
      let productId = button.getAttribute('data-product-id');
      
      // Find the product card and extract product data
      let card = button.closest('.featured-items__card');
      if (!card) {
        card = button.closest('.card-gallery');
      }
      if (!card) {
        card = button.closest('[data-product-card]');
      }
      if (!card) {
        card = button.closest('product-card');
      }
      
      if (!card) {
        console.warn('🎨 Could not find product card');
        return;
      }

      // Try to get product ID from card if not on button
      if (!productId) {
        productId = card.getAttribute('data-product-id');
      }
      
      // Fallback: extract from URL if ID not found in data attribute
      if (!productId) {
        const productLink = card.querySelector('a[href*="/products/"]');
        if (!productLink) {
          console.warn('🎨 Could not find product link in card');
          return;
        }
        const productUrl = productLink.getAttribute('href');
        if (!productUrl) {
          console.warn('🎨 Could not get href from product link');
          return;
        }
      }

      if (!productId) {
        console.warn('🎨 No product ID found');
        return;
      }

      this.openProductCustomizer(productId, card);
    });
  }

  /**
   * Open the product customizer for a given product ID
   */
  openProductCustomizer(productId, card) {
    // Set localStorage flag with the product ID
    try {
      localStorage.setItem('bookery-configurator-open-product', String(productId));
    } catch (e) {
      console.warn('Error setting localStorage:', e);
    }

    // Find the product link in the card and navigate to it
    // The App.tsx will detect the localStorage flag and open the modal
    const productLink = card?.querySelector('a[href*="/products/"]');
    
    if (productLink) {
      const productUrl = productLink.getAttribute('href');
      window.location.href = productUrl;
    } else {
      console.warn('🎨 No product link found for navigation');
      // Fallback: We'll just try to stay on the current page if we can't find the URL
      // The modal might open if we're on a product page with this product
    }
  }
}

// Initialize immediately
try {
  new ProductCustomizeHandler();
} catch (err) {
  console.warn('Error initializing ProductCustomizeHandler:', err);
}

} // End of initialization guard
